import React, { Component } from 'react'
import styled from 'styled-components'

class SimulationTimeouErrorV2 extends Component {
  render() {
    const { children } = this.props

    return (
      <Wrapper>
        <Content>
          <Title>Erro do Servidor</Title>
          <div>
            <Text>
              O servidor encontrou um problema e não conseguiu processar o seu
              pedido.
            </Text>
            <Text>Por favor tente novamente.</Text>
          </div>
          {children}
        </Content>
      </Wrapper>
    )
  }
}

export default SimulationTimeouErrorV2

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;
  gap: 16px;
`

const Title = styled.h3`
  overflow: hidden;
  color: #1d1e22;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Nunito;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
  letter-spacing: 1px;
  margin: 0;
  text-transform: unset;
`

const Text = styled.p`
  overflow: hidden;
  color: #3e3e3e;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin: 0;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`



// WEBPACK FOOTER //
// ./src/components/SimulationTimeoutErrorV2/index.js